/** How many rows from the end of the list start the next-page fetch (offsets API delay). */
export const OFFERS_LOAD_MORE_TRIGGER_OFFSET = 3;

/** Debounce before calling offers search after the user types in the filter bar. */
export const OFFERS_SEARCH_DEBOUNCE_MS = 300;

export const OfferType = {
	COUPON: "COUPON",
	DISCOUNT: "DISCOUNT",
};

export const SubOfferType = {
	TOA: "TOA",
	USER_BASED: "USER_BASED",
};

export const OfferStatus = {
	CREATED: "1",
	DRAFT: "2",
	PUBLISHED: "3",
	INACTIVE: "4",
	EXPIRED: "5",
};

export const OfferStatusLabels = {
	[OfferStatus.CREATED]: "Created",
	[OfferStatus.DRAFT]: "Draft",
	[OfferStatus.PUBLISHED]: "Published",
	[OfferStatus.INACTIVE]: "Inactive",
	[OfferStatus.EXPIRED]: "Expired",
};

export const ConditionSubject = {
	CART_PRICE: "CART_PRICE",
	DISH_PRICE: "DISH_PRICE",
	DISH_ID: "DISH_ID",
	DISH_CATEGORY: "DISH_CATEGORY",
};

export const ConditionSubjectLabels = {
	[ConditionSubject.CART_PRICE]: "Cart Price",
	[ConditionSubject.DISH_PRICE]: "Dish Price",
	[ConditionSubject.DISH_ID]: "Dish ID",
	[ConditionSubject.DISH_CATEGORY]: "Dish Category",
};

export const ConditionOperator = {
	EQUALS: "EQUALS",
	GTE: "GTE",
	LTE: "LTE",
	IN: "IN",
};

export const ConditionOperatorLabels = {
	[ConditionOperator.EQUALS]: "EQUALS",
	[ConditionOperator.GTE]: "GTE",
	[ConditionOperator.LTE]: "LTE",
	[ConditionOperator.IN]: "IN",
};

export const RuleOperator = {
	AND: "AND",
	OR: "OR",
};

export const ActionType = {
	PERCENT: "PERCENT",
	FLAT: "FLAT",
};

export const ActionTypeLabels = {
	[ActionType.PERCENT]: "Percent",
	[ActionType.FLAT]: "Flat",
};

export const ActionTarget = {
	DISH_PRICE: "DISH_PRICE",
	CART_PRICE: "CART_PRICE",
};

export const ActionTargetLabels = {
	[ActionTarget.DISH_PRICE]: "Dish Price",
	[ActionTarget.CART_PRICE]: "Cart Price",
};

export const OfferChannel = {
	APP: "app",
};

export const OfferChannelLabels = {
	[OfferChannel.APP]: "App",
};

export const OFFER_TYPE_OPTIONS = [
	{ head: "COUPON", value: OfferType.COUPON },
	{ head: "DISCOUNT", value: OfferType.DISCOUNT },
];

export const SUB_OFFER_TYPE_OPTIONS = [
	{ head: "TOA", value: SubOfferType.TOA },
	{ head: "USER_BASED", value: SubOfferType.USER_BASED },
];

export const OFFER_CHANNEL_OPTIONS = [
	{ head: OfferChannelLabels[OfferChannel.APP], value: OfferChannel.APP },
];

export const PRIORITY_DROPDOWN_OPTIONS = [1, 2, 3, 4, 5].map((p) => ({
	head: String(p),
	value: p,
}));

export const CONDITION_SUBJECT_OPTIONS = [
	{ head: ConditionSubjectLabels[ConditionSubject.CART_PRICE], value: ConditionSubject.CART_PRICE },
	{ head: ConditionSubjectLabels[ConditionSubject.DISH_PRICE], value: ConditionSubject.DISH_PRICE },
	{ head: ConditionSubjectLabels[ConditionSubject.DISH_ID], value: ConditionSubject.DISH_ID },
	// {
	// 	head: ConditionSubjectLabels[ConditionSubject.DISH_CATEGORY],
	// 	value: ConditionSubject.DISH_CATEGORY,
	// },
];

export const CONDITION_OPERATOR_OPTIONS = [
	{ head: ConditionOperatorLabels[ConditionOperator.EQUALS], value: ConditionOperator.EQUALS },
	{ head: ConditionOperatorLabels[ConditionOperator.GTE], value: ConditionOperator.GTE },
	{ head: ConditionOperatorLabels[ConditionOperator.LTE], value: ConditionOperator.LTE },
	{ head: ConditionOperatorLabels[ConditionOperator.IN], value: ConditionOperator.IN },
];

/** Operator dropdown options allowed per condition subject. */
export const CONDITION_OPERATOR_OPTIONS_BY_SUBJECT = {
	[ConditionSubject.DISH_ID]: [
		{ head: ConditionOperatorLabels[ConditionOperator.EQUALS], value: ConditionOperator.EQUALS },
	],
	[ConditionSubject.DISH_CATEGORY]: [],
	[ConditionSubject.CART_PRICE]: CONDITION_OPERATOR_OPTIONS,
	[ConditionSubject.DISH_PRICE]: CONDITION_OPERATOR_OPTIONS,
};

export const RULE_OPERATOR_OPTIONS = [
	{ head: "AND", value: RuleOperator.AND },
	{ head: "OR", value: RuleOperator.OR },
];

export const ACTION_TYPE_OPTIONS = [
	{ head: ActionTypeLabels[ActionType.PERCENT], value: ActionType.PERCENT },
	{ head: ActionTypeLabels[ActionType.FLAT], value: ActionType.FLAT },
];

export const ACTION_TARGET_OPTIONS = [
	{ head: ActionTargetLabels[ActionTarget.DISH_PRICE], value: ActionTarget.DISH_PRICE },
	{ head: ActionTargetLabels[ActionTarget.CART_PRICE], value: ActionTarget.CART_PRICE },
];

export const TermsConditionType = {
	PARAGRAPH: "paragraph",
	ORDERED_LIST: "orderedList",
};

export const TermsConditionTypeLabels = {
	[TermsConditionType.PARAGRAPH]: "Paragraph",
	[TermsConditionType.ORDERED_LIST]: "Ordered List",
};

export const TERMS_CONDITION_TYPE_OPTIONS = [
	{
		head: TermsConditionTypeLabels[TermsConditionType.PARAGRAPH],
		value: TermsConditionType.PARAGRAPH,
	},
	{
		head: TermsConditionTypeLabels[TermsConditionType.ORDERED_LIST],
		value: TermsConditionType.ORDERED_LIST,
	},
];

export const COMPATIBILITY_WILDCARD = "*";

/** Wizard mode for create vs edit offer forms. */
export const OfferFormMode = Object.freeze({
	CREATE: "create",
	EDIT: "edit",
});

/** Row-level change kinds returned by offer draft diffs. */
export const OfferRowChange = Object.freeze({
	ADDED: "added",
	UPDATED: "updated",
	REMOVED: "removed",
});
